<base-modal-component (onConfirm)="save()" [confirmButtonHidden]="published" [validation]="isValid()" class="base-modal"
                      confirmButtonText="Publish">
    <fields-list-component [fields]="fields" [value]="recipe"
                           name="custom_recipes_edit"></fields-list-component>
</base-modal-component>
